import { createContext } from 'react';

interface IVirtualizeContext {
  setRow: (index: string, height: number, child: React.ReactNode) => void;
  removeRow: (index: number) => void;
  width: number;
}

const EMPTY_FUNC = () => {
  /** DO NOTHING */
};

const initialValue: IVirtualizeContext = {
  setRow: EMPTY_FUNC,
  removeRow: EMPTY_FUNC,
  width: 0,
};

export default createContext(initialValue);
